import { AxiosResponse } from 'axios';
import Page from '@constants/page';
import { history } from '../agent';

export default function goToErrorPage(response: AxiosResponse): void {
  if (response.status === 401 || response.status === 403) {
    history.push(Page.FORBIDDEN.path);
    history.go(0);
  }
}
